import React, { useState, useEffect } from "react";

import noImage from "../../assets/images/no-image.jpg";
import "./Avatar.sass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCamera } from "@fortawesome/free-solid-svg-icons";
import * as api from "./../../api";
import CameraCaptureModal from "../CameraCaptureModal/CameraCaptureModal";
import compressImage from "../../utils/compressImage";

const Avatar = ({
  src,
  width = 50,
  editable = false,
  editCallback = () => {},
  isUploading = false,
  setIsUploading = () => {},
  customer = "",
}) => {
  const [newImage, setNewImage] = useState("");
  const [showCameraModal, setShowCameraModal] = useState(false);

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    event.target.value = null;
    if (!file) return;

    setIsUploading(true);
    try {
      const compressed = await compressImage(file);
      handleImageUpload(compressed);
    } catch {
      setIsUploading(false);
      setNewImage(src);
    }
  };

  const handleCameraCapture = (dataUrl) => {
    setIsUploading(true);
    handleImageUpload(dataUrl);
  };

  const handleImageUpload = (image) => {
    api.customers
      .changeProfilePicture(image, customer)
      .then((response) => {
        if (
          response.status &&
          response.status >= 200 &&
          response.status < 300
        ) {
          setIsUploading(false);
          setNewImage(response.data.profilePicture);
          editCallback(response.data.profilePicture);
        }
      })
      .catch(() => {
        setIsUploading(false);
        setNewImage(src);
        editCallback(src);
      });
  };

  return (
    <div
      className={"Avatar mx-auto" + (isUploading == true ? " uploading" : "")}
      style={{
        width,
        height: width,
        backgroundImage: `url(${
          newImage !== "" ? newImage : src ? src : noImage
        })`,
      }}
    >
      {editable && (
        <>
          <button
            type="button"
            className="avatar-edit avatar-capture"
            onClick={() => setShowCameraModal(true)}
            title="Take a photo"
          >
            <div className="avatar-edit-icon">
              <FontAwesomeIcon icon={faCamera} />
            </div>
          </button>
          <label htmlFor="editAvatar" className="avatar-edit">
            <input
              type="file"
              accept="image/*"
              id="editAvatar"
              name="editAvatar"
              className="Avatar-input"
              onChange={(event) => handleImageChange(event)}
            />
            <div className="avatar-edit-icon">
              <FontAwesomeIcon icon={faPen} />
            </div>
          </label>
          <CameraCaptureModal
            show={showCameraModal}
            onHide={() => setShowCameraModal(false)}
            onCapture={handleCameraCapture}
          />
        </>
      )}
    </div>
  );
};

export default Avatar;
